export const ACCESS_CONTROL = {
    "peltask": 1,
    "mym": 2,
    "medsheets" : 1,
    "medsheet"  : 1,
    "medsheets_advanced": 2,
    "treament": 2,
    "currentmeds": 2,
    "loaform": 2,
    "hcporder": 2,
    "editprescription" : 2,
    "medtrackui": 1,
    "telephoneorder": 2,
    "tansferform": 2,
    "currentmedlist": 2,
    "patientprofile": 1,
}